var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticStyle:{"width":"100%"}},[_c('div',{staticClass:"divimg"},[_c('img',{attrs:{"src":_vm.dataItem.imgUrl}}),_c('p',{domProps:{"innerHTML":_vm._s(_vm.dataItem.content)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }